import {Authority} from '@/shared/security/authority'

const RechercheDossier = () => import('@/components/recherche/RechercheDossier.vue')

export default [
  {
    path: '/recherche/autorisationConstruire',
    name: 'RechercheAutorisationConstruire',
    component: RechercheDossier
  },
  {
    path: '/recherche/ventesAppartements',
    name: 'RechercheVentesAppartements',
    component: RechercheDossier
  },
  {
    path: '/recherche/planAffectation',
    name: 'RecherchePlanAffectation',
    component: RechercheDossier
  },
  {
    path: '/recherche/diversAmenagement',
    name: 'RechercheDiversAmenagement',
    component: RechercheDossier
  },
  {
    path: '/rechercheAvancee',
    name: 'RechercheAvancee',
    component: RechercheDossier
  }
]
